import NavigationItem from "types/globals/navigationBar/navigationItem";

const determineActiveHeader = (
  items: NavigationItem,
  activeRoute: string | undefined
) => {
  var active = false;
  items.pages.forEach((navigationItem, _) => {
    var activeItem =
      activeRoute === "/" + navigationItem.uri ||
      activeRoute === "/" + navigationItem.uri + "/" ||
      (activeRoute === "/" && navigationItem.uri === "__home__");

    if (!active && activeItem) {
      active = true;
    }
  });

  return active;
};

export default determineActiveHeader;
